import { Flex, Button } from '@cycle-app/ui';
import { isEqual } from 'lodash';

import { useChangelog } from 'src/hooks/releases/useChangelog';
import { ChangelogBuilderFormData } from 'src/hooks/releases/useChangelogBuilderForm';
import { useChangelogBuilderFormContext } from 'src/hooks/releases/useChangelogBuilderFormContext';
import { useChangelogUpdate } from 'src/hooks/releases/useChangelogUpdate';

import { Container } from './ChangelogBuilderSubmit.styles';

export const ChangelogBuilderSubmit = () => {
  const {
    formState, watch, handleSubmit, reset,
  } = useChangelogBuilderFormContext();
  const { changelog } = useChangelog();
  const {
    changelogUpdate, isLoading,
  } = useChangelogUpdate();
  const socialLinkText = watch('socialLinkText');
  const socialLinkURL = watch('socialLinkURL');
  const subtitle = watch('subtitle');
  const title = watch('title');
  const values = {
    socialLinkText,
    socialLinkURL,
    subtitle,
    title,
  };

  const onSubmit = async (data: ChangelogBuilderFormData) => {
    if (!isLoading && changelog?.id) {
      const result = await changelogUpdate({
        ...data,
        id: changelog.id,
      });
      if (result?.data?.updateChangelog?.id) {
        reset(data);
      }
    }
  };

  return (
    <Container>
      {!isEqual(formState.defaultValues, values) ? (
        <Flex $grow={1}>
          <Flex style={{ marginLeft: 'auto' }} $gap={16} $align="center">
            <Button size="M" variant="outlined-alt" onClick={() => reset()}>Discard</Button>
            <Button isLoading={isLoading} size="M" onClick={handleSubmit(onSubmit)}>Save</Button>
          </Flex>
        </Flex>
      ) : null}
    </Container>
  );
};
